export default "__VITE_ASSET__B44LSGy6__"